import { render, staticRenderFns } from "./SickDayLegend.vue?vue&type=template&id=f0979ac2&"
import script from "./SickDayLegend.vue?vue&type=script&lang=js&"
export * from "./SickDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0979ac2')) {
      api.createRecord('f0979ac2', component.options)
    } else {
      api.reload('f0979ac2', component.options)
    }
    module.hot.accept("./SickDayLegend.vue?vue&type=template&id=f0979ac2&", function () {
      api.rerender('f0979ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/SickDayLegend.vue"
export default component.exports